import React from 'react';
import { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

//
// A reusable spinner.
//
// Delay in milliseconds - to show spinner only if it takes too long time.
// Visual space should be taken to avoid jumping & flickering.
// When hidden=true and updating it to false, the spinner will be shown after delay.
//
export const Spinner = ({ delay, hidden, size, sx }) => {
    if (delay === undefined) { delay = 0; }
    if (hidden === undefined) { hidden = false; }
    if (size === undefined) { size = 60; }

    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
        let timer;
        if (!hidden) {
            timer = setTimeout(() => {
                setShowSpinner(true);
            }, delay); // Delay in milliseconds
        } else {
            setShowSpinner(false);
        }
        return () => clearTimeout(timer); // This will clear the timer when the component unmounts
    }, [hidden]);

    // Use opacity: 0 - to reserve visual space.
    const hideStyle = {
        opacity: (showSpinner && !hidden) ? 1 : 0
    };

    return (
        <CircularProgress className="common-spinner" style={hideStyle} size={size} sx={sx} />
    )
}
